<div class="partner-gateway-permissions">
  <div class="partner-gateway-permission-block">
    <h2>JM Gateway Permissions</h2>
    <div class="fx-layout-row fx-layout-xs-column">
      <div class="fx-flex-25">
        <a href="javascript:void(0)" (click)="openPermissionUrl()">Permission URL</a>
      </div>
    </div>
  </div>
</div>